import { api } from "@services/baseURL";

export const SavePlanoAcaoSharepoint = async (formData) => {
  try {
    const response = await api.post(
      `PlanoAcao/upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      `Erro ao salvar plano de ação para o processo de id: ${formData.idProcesso}:`,
      error
    );
    throw error;
  }
};

export const DeletePlanoAcao = async (id) => {
  try {
    await api.delete(`PlanoAcao/${id}`);
    return true;
  } catch (error) {
    console.error('Erro ao deletar plano de ação:', error);
    throw error;
  }
};

export const GetAllPlanosAcao = async (pageSize, rowsPerPage) => {
  try {
    const response = await api.get(`PlanoAcao`, {
      headers: {
        Authorization: `Bearer authToken`,
      },
      params: {
        pageNumber: pageSize,
        pageSize: rowsPerPage,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar todos os planos de ação:', error);
    throw error;
  }
};

export const GetAllPlanosAcaoByIdProcessoAndIdUnidadeGerencia = async (
  pageSize, 
  rowsPerPage, 
  idProcesso, 
  idUnidadeGerencia) => {

  try {
    const response = await api.get(`PlanoAcao/${idProcesso}/${idUnidadeGerencia}`, {
      headers: {
        Authorization: `Bearer authToken`,
      },
      params: {
        pageNumber: pageSize,
        pageSize: rowsPerPage,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar os planos de ação associados ao processo e a unidadeGerencia:', error);
    throw error;
  }
};

export const GetByIdPlanoAcao = async (id) => {
  try {
    const response = await api.get(`PlanoAcao/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar plano de ação por id:', error);
    throw error;
  }
};

export default {
  SavePlanoAcaoSharepoint,
  DeletePlanoAcao,
  GetByIdPlanoAcao,
  GetAllPlanosAcao,
  GetAllPlanosAcaoByIdProcessoAndIdUnidadeGerencia,
};